import {
    FIND_STORES_PAGE,
    FIND_MORE_STORES_PAGE,
    PRE_POPULATE_STORES,
    FIND_STORES_PAGE_RESET,
    FIND_STORES_PAGE_FILTER,
    FIND_STORES_TOGGLE_MAP,
    GET_FILTER_BY_SERVICES,
    GET_FILTER_BY_SERVICES_SUCCESS,
    GET_FILTER_BY_SERVICES_FAILURE,
} from '../actionTypes/FindAStorePageActionTypes';
import { RESET_NATIVE_LAT_LONG } from '../actionTypes/NativeAppActionTypes';

const findStoresPage = (payload) => ({
    type: FIND_STORES_PAGE,
    payload,
});

const prePopulateStores = () => ({
    type: PRE_POPULATE_STORES,
});

const findMoreStoresPage = (payload) => ({
    type: FIND_MORE_STORES_PAGE,
    payload,
});

const findStoresPageReset = () => ({
    type: FIND_STORES_PAGE_RESET,
});

const findStoresPageFilter = (payload) => ({
    type: FIND_STORES_PAGE_FILTER,
    payload,
});

const findStoresToggleMap = () => ({
    type: FIND_STORES_TOGGLE_MAP,
});

const findStoresFilterPills = () => ({
    type: GET_FILTER_BY_SERVICES,
});

const findStoresFilterPillsSuccess = (payload) => ({
    type: GET_FILTER_BY_SERVICES_SUCCESS,
    payload,
});

const findStoresFilterPillsFailure = (payload) => ({
    type: GET_FILTER_BY_SERVICES_FAILURE,
    payload,
});

const resetNativeLatLong = () => ({
    type: RESET_NATIVE_LAT_LONG,
});

export default {
    findStoresPage,
    findMoreStoresPage,
    prePopulateStores,
    findStoresPageReset,
    findStoresPageFilter,
    findStoresToggleMap,
    findStoresFilterPills,
    findStoresFilterPillsSuccess,
    findStoresFilterPillsFailure,
    resetNativeLatLong,
};
